export default {
  data () {
    return {
      timer: null
    }
  },
  beforeRouteEnter (to, form, next) {
    next(vm => {
      vm.timer = window.setInterval(() => {
        setTimeout(() => {
          vm.getTodoCount()
        }, 1)
      }, 60000)
    })
  },
  deactivated () {
    clearInterval(this.timer)
  }
}
